// extracted by mini-css-extract-plugin
module.exports = {"row":"_2KLm2YP _2wW_gNj","col":"_3YAlL8G _2VphNyU _3H_L-Um","half_width":"_27CwEGg _1npT0qO _2KyqKMI","section":"_2hUBy_Z","error":"_1wsvnuJ","notice":"_2oYRWKR"};